app.filter('sum', function () {
  return function (string) {
    return string ? (string + '').replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ') : string;
  };
});
